<template>
  <div class="v-divider-ui"></div>
</template>
